/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EnrollmentPreviewResponsePhase = typeof EnrollmentPreviewResponsePhase[keyof typeof EnrollmentPreviewResponsePhase];


export const EnrollmentPreviewResponsePhase = {
  revealing: 'revealing',
  preparing: 'preparing',
  rendering: 'rendering',
  ready: 'ready',
  failed: 'failed',
} as const;
